import { useReduxSelector } from '../../../../../infra/redux-bridge';
export var useSearchFilter = function () {
    var searchFilter = useReduxSelector('engagement.searchString');
    var filterBySearch = function (row) {
        if (!searchFilter) {
            return true;
        }
        var campaign = row.original;
        return campaign.formattedSubject.toLowerCase().includes(searchFilter.toLowerCase());
    };
    return {
        searchFilter: searchFilter,
        filterBySearch: filterBySearch,
    };
};
